import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		height: '-webkit-fill-available',
		minHeight: '300px',
		justifyContent: 'center',
		'& > * + *': {
			margin: theme.spacing(2),
		},
	},
}));

const Loader = () => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<CircularProgress size={200} color="secondary" />
		</div>
	);
}

export default Loader
